/* global $ */
import Quiz from './quiz'

let quiz

function selectedAnswers() {
  let answers = []
  $("input[name='option']:checked").each(function () {
    answers.push(parseInt($(this).val()))
  })
  return answers
}

function correctAnswers(currentQuestion) {
  return currentQuestion.answers
    .filter((element) => element.correct)
    .map((element) => parseInt(element.id))
}

function correct(currentQuestion) {
  return (
    JSON.stringify(selectedAnswers().sort()) ===
    JSON.stringify(correctAnswers(currentQuestion).sort())
  )
}

$(document).ready(() => {
  $('#begin').css('display', 'block')

  $('#begin').click(() => {
    $('#begin').prop('disabled', true)
    $('#begin').html('<i class="fas fa-spinner fa-pulse text-white"></i>')
    quiz = new Quiz()
    quiz.start().then(() => {
      $('div.welcome').css('display', 'none')
      $('div.question').css('display', 'block')
      $('div.user-input').css('display', 'flex')
    })
  })

  $('input.option').change(() => {
    if ($("input[name='option']:checked").val()) {
      $('#check').prop('disabled', false)
    } else {
      $('#check').prop('disabled', true)
    }
  })

  $('#check').click(async () => {
    $('#check').prop('disabled', true)
    $('#check').html('<i class="fas fa-spinner fa-pulse text-white"></i>')
    $('input[type=radio]').prop('disabled', true)
    $('.question').css('opacity', '0.2')
    $('.user-input').hide()

    if (correct(quiz.currentQuestion)) {
      $('#rationale').removeClass('incorrect')
      $('#rationale').addClass('correct')
      $('#rationale span#verdict').html(
        "<span>You are correct!</span><i class='fa fa-check fa-2x'></i>"
      )
    } else {
      $('#rationale').removeClass('correct')
      $('#rationale').addClass('incorrect')
      $('#rationale span#verdict').html(
        `<span>Correct answer: ${quiz.correctAnswers}.</span> <i class='fa fa-times fa-2x'></i>`
      )
    }
    $('#rationale p').text(quiz.currentQuestion.rationale)
    $('#rationale').show()
  })

  $('#next').click(async () => {
    $('#next').prop('disabled', true)
    $('#next').html('<i class="fas fa-spinner fa-pulse text-white"></i>')
    await quiz.submitAnswer(selectedAnswers())
    $('input.option').prop('checked', false)
    $('#next').html('Next')
    $('#next').prop('disabled', false)
    $('input[type=radio]').prop('disabled', false)
    $('.question').css('opacity', '1')
    $('#check').text('Check')
    $('.user-input').show()
    $('#rationale').hide()
  })
})
